export class EmailDto {
	email: string;

	constructor(email: string) {
		this.email = email;
	}
}
